<template>
  <div>
    <z-centralized-toolbar>
      <v-btn
        id="btn_adicionar"
        depressed
        rounded
        color="primary"
        :to="{ name: 'PedidosCompraAdicionar' }"
      >
        <v-icon left>mdi-plus</v-icon>Novo Pedido
        <v-tooltip bottom activator="#btn_adicionar">Novo Pedido</v-tooltip>
      </v-btn>

      <v-btn
        id="btn_atualizar"
        icon
        text
        :ripple="false"
        :loading="$store.state.loading"
        @click="refresh"
      >
        <v-icon>refresh</v-icon>
        <v-tooltip bottom activator="#btn_atualizar">Atualizar</v-tooltip>
      </v-btn>

      <div style="width: 300px;">
        <v-text-field
          rounded
          outlined
          single-line
          dense
          label="Pesquisar"
          autofocus
          clearable
          hide-details
          prepend-inner-icon="search"
          v-model="search"
          @keydown.enter="refresh"
          @click:clear="limparBusca"
        ></v-text-field>
      </div>
    </z-centralized-toolbar>

    <z-container>
      <h3 class="text-body-1 mb-3">Pedidos de Compra</h3>

      <v-card>
        <v-data-table
          disable-pagination
          disable-sort
          :options.sync="options"
          :server-items-length="total_de_registros"
          :footer-props="$globals.FOOTER_PROPS"
          :items="pedidoscompra"
          :headers="headers"
          :loading="false"
          style="cursor: pointer"
          @click:row="visualizar"
        >
          <template v-slot:item.data_emissao="{item}">
            {{ item.data_emissao | dataBR }}
          </template>

          <template v-slot:item.status="{item}">
            <v-chip small :color="corChip(item.status)" dark>{{ item.status }}</v-chip>
          </template>

          <template v-slot:item.opcoes="{ item }">

            <v-tooltip bottom>
              <template #activator="{ on, attrs }">
                <v-btn 
                  :color="item.fornecedor.celular ? '' : 'grey'"
                  icon
                  v-bind="attrs"
                  v-on="on"
                  @click.stop="abrirEnviarPedido(item)"
                >
                  <v-icon>{{ $icon.WHATSAPP }}</v-icon>
                </v-btn>
              </template>
              <span>Enviar WhatsApp</span>
            </v-tooltip>

            <v-btn icon @click.stop="visualizar(item)">
              <v-icon>mdi-eye</v-icon>
            </v-btn>

            <v-btn icon @click.stop="editar(item)" >
              <v-icon>mdi-pencil</v-icon>
            </v-btn>

            <!-- <v-btn icon @click.stop="imprimir(item)">
              <v-icon>mdi-printer</v-icon>
            </v-btn> -->

            <v-btn icon @click.stop="perguntarExcluir(item)" v-if="$auth.can('pedidoscompra:excluir') && item.status !== 'Entregue'">
              <v-icon>mdi-delete</v-icon>
            </v-btn>

          </template>
        </v-data-table>
      </v-card>
    </z-container>

    <z-dialogo-sim-nao
      ref="dialogoRemoverPedidoCompra"
      titulo="Remover pedido de compra?"
      botaoSim="Remover"
      botaoNao="Cancelar"
      :loading="excluindo"
    >
      O pedido de compra será removido. Deseja continuar?
    </z-dialogo-sim-nao>

    <DialogoEnviarPedidoWhatsapp 
      ref="dialogoEnviarPedidoWhatsapp"
      @enviar="enviarPedidoWhatsapp"
    ></DialogoEnviarPedidoWhatsapp>

  </div>
</template>

<script>
import { mapMutations, mapActions, mapState, mapGetters } from "vuex";
import config from "@/app/config";
import DialogoEnviarPedidoWhatsapp from './DialogoEnviarPedidoWhatsapp.vue';

export default {
  name: "PedidosCompraLista",

  components: {
    DialogoEnviarPedidoWhatsapp,
  },

  data() {
    return {
      headers: [
        { text: "Pedido", value: "id", width: "100px" },
        { text: "Data", value: "data_emissao", width: "150px" },
        { text: "Forenecedor", value: "fornecedor.razao" },
        { text: "Itens", value: "itens_count", width: "150px", align: "center" },
        { text: "Status", value: "status", width: "150px", align: "center" },
        { text: "Opções", value: "opcoes", width: "180px", align: "center", sortable: false, },
      ],
      data: this.hoje(),
      pagination: {},
      totalItens: 0,
      excluindo: false,
      estornando: false,
      pedido: {
        cliente: {
          razao: "",
        },
      },
      exibir_filtro: false,
    };
  },

  beforeMount() {
    // this.$store.dispatch("carregarConfiguracoes");
    // this.$store.dispatch("listas/clientes");
    // this.$store.dispatch("listas/vendedores");
  },

  mounted() {
    this.setTitulo("Pedidos de Compra");
    this.refresh();
  },

  computed: {
    ...mapState("pedidoscompra", ["pedidoscompra", 'total_de_registros']),

    search: {
      get() {
        return this.$store.state.pedidoscompra.search;
      },
      set(search) {
        this.$store.commit("pedidoscompra/SET_SEARCH", search);
      },
    },

    options: {
      get() {
        return this.$store.state.pedidoscompra.pagination;
      },
      set(options) {
        this.$store.commit("pedidoscompra/UPDATE_PAGINATION", options);
      },
    },

  },

  methods: {
    ...mapMutations(["setTitulo", "LOADING_OFF"]),
    ...mapActions("pedidoscompra", ["listar", "excluir", "abrir"]),

    async refresh() {
      try {
        await this.listar();
      } catch (error) {
        this.$eventbus.erro("Não foi possível obter a lista de pedidos de compra.", error);
        this.LOADING_OFF();
      }
    },

    editar(pedido) {
      this.$router.push({ name: "PedidosCompraEditar", params: { id: pedido.id } });
    },

    visualizar(pedido) {
      this.$router.push({ name: "PedidosCompraVisualizar", params: { id: pedido.id } });
    },

    limparBusca() {
      this.search = null;
      this.refresh();
    },

    imprimir(pedido) {
      // this.abrirJanela(window.location.origin + '/pedidos/'+ pedido.id +'/imprimir');
      this.abrirJanela(
        config.BASE_URL_PRINT + "/pedidoscompra/" + pedido.id + "/imprimir"
      );
    },

    corChip(situacao) {
      switch (situacao) {
        case "Pendente":
          return "orange";
          break;

        case "Parcial":
          return "cyan";
          break;

        case "Cancelado":
          return "red";
          break;

        case "Entregue":
          return "green";
          break;

        default:
          break;
      }
    },

    // perguntarExcluir(pedido) {
    //   this.pedido = pedido;
    //   this.$refs.dialogoRemoverPedidoCompra.abrir().then(async (response) => {
    //     if (response == true) await this.confirmarExcluir();
    //   });
    // },

    async perguntarExcluir(pedido) {
      let response = await this.$refs.dialogoRemoverPedidoCompra.abrir();
      if (response == false) {
        return;
      }

      try {
        this.$refs.dialogoRemoverPedidoCompra.startLoading();
        this.excluindo = true;
        await this.excluir(pedido);
        this.$eventbus.notificar("Pedido removido com sucesso!");
        this.$refs.dialogoRemoverPedidoCompra.fechar();
      } catch (error) {
        this.$eventbus.erro("Não foi possível cancelar o pedido.", error);
        console.log(error);
      } finally {
        this.excluindo = false;
        this.$refs.dialogoRemoverPedidoCompra.stopLoading();
      }
    },

    abrirEnviarPedido(pedido) {
      if (!pedido.fornecedor.celular) {
        this.$eventbus.erroSistema("O fornecedor não possui número de celular cadastrado.");
        return;
      }
      this.$refs.dialogoEnviarPedidoWhatsapp.abrir(pedido);
    },

    async enviarPedidoWhatsapp(pedido) {
      try {
        await this.$axios.post(`/pedidoscompra/${pedido.id}/enviar`);
        this.$eventbus.notificar('Pedido de compra enviado via WhatsApp com sucesso.');
      } catch (error) {
        this.$eventbus.erro('Não foi possível enviar o pedido de compra via WhatsApp.', error);
        throw error;
      } finally {
        // this.LOADING_OFF();
      }
    },
  },

  watch: {
    options: {
      handler() {
        this.refresh();
      },
      deep: true,
    },
  },
};
</script>

<style scoped></style>
